// extracted by mini-css-extract-plugin
module.exports = {"breakpointSm":"720","breakpointMd":"1250","breakpointLg":"1650"};